<template>
  <div id="packages-edit">

    <IForm :label-width="85" ref="formInline" :model="edit" :elem="editElem" :rules="editRule"
           @on-submit="toSubmit" :submit="false" :showMessage="true">
      <div slot="extend">
        <Row>
          <Col span="8">
            <FormItem label="项目名称" prop="name">
              <Input v-model="edit.name" type="text" placeholder="请输入项目名称" maxlength="50"/>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label-width="45" label="标签" prop="flag">
              <Input v-model="edit.flag" type="text" placeholder="请输入标签" maxlength="50"/>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem :label-width="45" label="编码" prop="code">
              <Input v-model="edit.code" type="text" placeholder="请输入编码" maxlength="100" disabled/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="项目类型" prop="type">
              <Select v-model="edit.projectType" style="width: 100%;">
                <Option v-for="item in enums.projectTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label-width="110" label="价格" prop="price">
              <Input v-model="edit.price" type="text" placeholder="请输入价格" maxlength="50"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="必填限制" prop="isRequired">
              <Select v-model="edit.isRequired" style="width: 100%;">
                <Option v-for="item in isRequiredList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label-width="110" label="小程序显示" prop="isShow">
              <Select v-model="edit.isShow" style="width: 100%;">
                <Option v-for="item in isShowList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="8">
            <FormItem label="体检项目" prop="type">
              <Select v-model="edit.isPhysical" style="width: 100%;">
                <Option v-for="item in enums.pysicalList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="业务类型" prop="businessType">
              <Select v-model="edit.businessType" style="width: 100%;">
                <Option v-for="item in businessTypeList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="类型" prop="type">
              <Select v-model="edit.type" style="width: 100%;">
                <Option v-for="item in enums.physicalProjectTypes" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="状态" prop="status">
              <Select v-model="edit.status" style="width: 100%;">
                <Option v-for="item in enums.status" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem :label-width="110" label="自动更新检查" prop="inspectStatus">
              <Select v-model="edit.inspectStatus" style="width: 100%;">
                <Option v-for="item in inspectStatusList" :value="item.value" v-bind:key="item.value">{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="备注" prop="remark">
              <Input v-model="edit.remark" type="textarea" placeholder="请输入备注" :rows="2"/>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem label="项目告知书">
              <el-upload action="#" :limit="1" :file-list="fileList" list-type="picture-card" :auto-upload="false"
                         :class="{ hideUpload: hideUpload }" :on-change="handleChange"
                         :on-preview="handlePreview" :on-remove="handleRemove" :before-upload="beforeAvatarUpload">
                <i class="el-icon-plus avatar-uploader-icon"/>
                <div slot="tip" class="el-upload__tip">只能上传png/jpg/jpeg文件，且大小不超过500MB</div>
              </el-upload>
              <Modal v-model="dialogVisible" width="50%" title="预览" :styles="{'top':'60px'}" :footerHide="true">
                <img style="display: block; max-width: 100%; margin: 0px auto;" :src="dialogImageUrl">
              </Modal>
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="24">
            <FormItem>
              <TabPanel ref="editTabPanel" :packagesIds="packagesIds" :fieldIds="fieldIds" @on-packagesIds="setPackagesIds" @on-fieldIds="setFieldIds"/>
            </FormItem>
          </Col>
        </Row>
      </div>
    </IForm>

  </div>
</template>
<script>

import {_get, _save} from "@/services/screeningConfig/physicalProject.js";
import TabPanel from "./TabPanel";
import {enums} from "@/services/enums";
export default {
  name: "PhysicalProjectEdit",
  components: {
    TabPanel
  },
  data() {
    return {
      edit: {
        name: "",
        code: "",
        price: "0.00",
        type: 1,
        projectType: 1,
        isPhysical: 1,
        parentId: "",
        inspectStatus: "",
        isRequired: 1,
        businessType: 1,
        isShow: 1,
        status: 1,
        packagesIds: [],
        fieldIds: [],
      },
      packagesIds: [],
      fieldIds: [],
      inspectStatusList:[
        {label: '是', value: 1},
        {label: '否', value: 2},
      ],
      isRequiredList:[
        {label: '弹框提示', value: 1},
        {label: '限制提交', value: 2},
      ],
      isShowList:[
        {label: '显示', value: 1},
        {label: '不显示', value: 2},
      ],
      businessTypeList:[
        {label: '通用', value: 1},
        {label: '幼儿园', value: 2},
        {label: '小学', value: 3},
        {label: '中学', value: 4},
        {label: '大学', value: 5},
      ],
      applicableAge:false,
      fileList: [],
      hideUpload: false,
      dialogImageUrl: '',
      dialogVisible: false,
      enums: enums,
      init: "",
      loading: {
        form: false,
        btn: false
      },
      editElem: [],
      editRule: {
        name: [
          {required: true, message: '项目名称不能为空', trigger: 'blur'},
          {maxlength: 50, message: "项目名称长度不能超过50", trigger: 'blur'}
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
            type: 'number'
          }
        ],
      },
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      this.packagesIds = [];
      this.fieldIds = [];
      this.fileList = [];

      this.$refs["formInline"].handleReset();
      if (!row) {
        this.handleCreate();
      } else {
        this.handleEdit(row);
      }
      this.$forceUpdate();
    },
    handleCreate() {
      this.edit = Object.assign({}, this.init);
    },
    handleEdit(row) {
      _get({id: row.id}).then(res => {
        this.edit = Object.assign({}, res.data);

        let editTabPanel = this.$refs['editTabPanel'];
        this.$nextTick(() => {
          if (this.edit.packagesIds && this.edit.packagesIds.length > 0) {
            this.packagesIds = this.edit.packagesIds;
            editTabPanel.$refs['packagesTree'].setCheckedKeys(this.edit.packagesIds)
          }
        })

        this.$nextTick(() => {
          if (this.edit.fieldIds && this.edit.fieldIds.length > 0) {
            this.fieldIds = this.edit.fieldIds;
            editTabPanel.$refs['fieldTree'].setCheckedKeys(this.edit.fieldIds)
          }
        })

        if(this.edit.notices){
          this.fileList = [{name: this.edit.noticesFileName, url: this.edit.notices}];
        }
        this.hideUpload = this.fileList.length >= 1;
        this.$forceUpdate();
      })
    },
    setPackagesIds(result) {
      this.edit.packagesIds = result;
    },
    setFieldIds(result) {
      this.edit.fieldIds = result;
    },
    handleSubmit() {
      this.$refs["formInline"].handleSubmit('form');
    },
    toSubmit() {
      if(this.fileList && this.fileList.length > 0 && this.fileList[0].raw){
        this.edit.file = this.fileList[0].raw;
      }
      _save(this.edit).then(res => {
        if (res.errcode === 1) {
          this.$message.success("保存成功");
          this.$emit("on-submit", false);
        } else {
          this.$message.error(res.errmsg);
        }
      }).catch(() => {});
    },
    handleChange(file, fileList){
      this.fileList = fileList;
      this.dialogImageUrl = file.url;
      this.hideUpload = fileList.length >= 1;
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.dialogImageUrl = "";
      this.edit.notices = "";
      this.hideUpload = fileList.length >= 1;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || 'image/png' || 'image/jpeg';
      const isLt500M = file.size / 1024 / 1024 < 500;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 PNG/JPG/JPEG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 500MB!');
      }
      return isJPG && isLt500M;
    }
  }
};
</script>
<style lang="postcss" scoped>
/* 隐藏上传按钮 */
.hideUpload /deep/ .el-upload--picture-card {
  display: none !important;
}
</style>
